export * from "./detail";
export * from "./related-whitepaper";
